// components/ui/molecules/RecipeMetaInfo.tsx
import React from 'react';
import { AiFillStar, AiOutlineStar } from 'react-icons/ai';

type RecipeMetaInfoProps = {
  rating: number | null;
  reviewCount: number;
  duration: number;
  ingredientCount: number;
};

export const RecipeMetaInfo = ({
  rating,
  reviewCount,
  duration,
  ingredientCount,
}: RecipeMetaInfoProps) => {
  const scrollToReviews = () => {
    const el = document.getElementById('reviews-section');
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  const renderStars = () => {
    const rounded = Math.round(rating || 0);
    return (
      <div className="flex items-center gap-[2px]">
        {[1, 2, 3, 4, 5].map((i) =>
          rating && reviewCount > 0 && i <= rounded ? (
            <AiFillStar key={i} className="text-black w-[14px] h-[14px]" />
          ) : (
            <AiOutlineStar key={i} className="text-black w-[14px] h-[14px]" />
          )
        )}
      </div>
    );
  };

  return (
    <div className="flex justify-around items-center border border-gray-300 rounded-md px-4 py-3 text-sm text-gray-800 bg-white shadow-sm mb-4 mt-4">
      {/* Rating */}
      <div
        className="flex flex-col items-center justify-center text-center cursor-pointer"
        onClick={scrollToReviews}
      >
        <div className="font-bold text-base flex items-baseline gap-1">
          {reviewCount > 0 ? rating?.toFixed(2) : '—'}
          {reviewCount > 0 && (
            <span className="text-[11px] text-gray-500 font-normal">
              ({reviewCount})
            </span>
          )}
        </div>
        {renderStars()}
      </div>

      {/* Vertical divider */}
      <div className="w-px h-10 bg-gray-300 mx-3" />

      {/* Time */}
      <div className="flex flex-col items-center justify-center text-center">
        <div className="font-bold text-base">{duration} min.</div>
        <div className="text-xs text-gray-500">Total Time</div>
      </div>

      {/* Vertical divider */}
      <div className="w-px h-10 bg-gray-300 mx-3" />

      {/* Ingredients */}
      <div className="flex flex-col items-center justify-center text-center">
        <div className="font-bold text-base">{ingredientCount}</div>
        <div className="text-xs text-gray-500">ingredients</div>
      </div>
    </div>
  );
};
